export default __webpack_public_path__ + "2d2ae2556b24a45ff8d5ed86b07b5783.woff";